<template>
  <div
    :class="$style.base"
    v-if="!googleReserveLoading && googleReserveEnabled"
  >
    <BaseCard gray>
      <Flex direction="column">
        <BaseToggle
          v-model="showGoogleReview"
          :label="$t('feedback.google_review.label')"
          :description="$t('feedback.google_review.description')"
          v-test="'feedback-google-review'"
        />
        <BaseText
          :href="helpCenterArticleUrl($t('feedback.google_review.learn_more_url'))"
          v-test="'feedback-google-review-learn-more'"
        >
          {{ $t('global.learn_more') }}
        </BaseText>
      </Flex>
    </BaseCard>
  </div>
  <div
    :class="$style.base"
    v-else-if="!googleReserveLoading && googleReserveEligible"
    v-test="'feedback-google-review-enable'"
  >
    <BaseCard gray>
      <Flex direction="column">
        <BaseText bold>
          {{ $t('feedback.google_review.enable_title') }}
        </BaseText>
        <BaseText>
          {{ $t('feedback.google_review.enable_description') }}
        </BaseText>
        <BaseText
          :routerLink="{ name: 'online-google-reserve' }"
          v-test="'feedback-google-review-enable-link'"
        >
          {{ $t('feedback.google_review.enable_link') }}
        </BaseText>
      </Flex>
    </BaseCard>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { helpCenterArticleUrl } from '@/helpers/help-center';
import { flash } from '@/helpers/ui';
import { useCompanyStore } from '@/stores/company';
import { useGoogleReserveStore } from '@/stores/google-reserve';

const { t } = useI18n();

const companyStore = useCompanyStore();
const { companySettings } = storeToRefs(companyStore);
const { updateCompany } = companyStore;

const {
  isEnabled: googleReserveEnabled,
  showIntegration: googleReserveEligible,
  loading: googleReserveLoading,
} = storeToRefs(useGoogleReserveStore());

const showGoogleReview = computed({
  get: () => companySettings.value.customers.feedbackGoogleReview,
  set: (value: boolean) => {
    updateCompany({
      settings: {
        customers: {
          feedbackGoogleReview: value,
        },
      },
    }).then(() => {
      flash(t('global.flash.settings_updated'));
    });
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  margin-bottom: $spacing;
}
</style>
